module.exports = __webpack_public_path__ + "img/no-image.e8a2f741.png";